import axios from 'axios';

export function getSubscribers({ limit, page, filters }) {
    return axios({
        method: 'get',
        url: `/api/v1/subscribe/upc`,
        params: {
            limit,
            page,
            filters: JSON.stringify({
                ...filters,
                search: filters.search.length > 2 ? filters.search : undefined,
            })
        },
        withCredentials: true,
    })
        .then(response => response)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/users/subscribers.js